import React from "react";
import { Grid } from "@material-ui/core";
import SubscriptionCard from "./SubscriptionCard";
import NoData from "components/NoData";
import { makeStyles } from "@material-ui/styles";

export default function SubscriptionsGrid({
  listData,
  openEdition,
  afterSuccessUpdate,
}) {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      {listData && listData.length > 0 ? (
        listData.map((item, index) => (
          <Grid
            item
            xs={12}
            md={12}
            lg={6}
            xl={4}
            key={index}
            className={classes.subscriptionGrid}
          >
            <SubscriptionCard
              data={item}
              openEdition={openEdition}
              afterSuccessUpdate={afterSuccessUpdate}
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <NoData />
        </Grid>
      )}
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  subscriptionGrid: {
    "@media (min-width: 600px) and (max-width: 960px)": {},
  },
}));
